export default {
    methods: {
        getOfferPosition(index, options = {}) {
            const columnCount = this.breakpoint?.columnCount;
            const OFFERS_PER_ROW_MOBILE = 2;
            const OFFERS_PER_ROW_CUT = columnCount - 1;
            const OFFERS_PER_ROW_DEFAULT = options.groupIndex !== undefined ? OFFERS_PER_ROW_CUT : columnCount;
            const ADAPTIVE_OFFERS_PER_ROW = this.$screen.isMobile ? OFFERS_PER_ROW_MOBILE : OFFERS_PER_ROW_DEFAULT;

            let pos = index + 1;
            let row = Math.floor(index / ADAPTIVE_OFFERS_PER_ROW) + 1;
            let page = isNaN(parseInt(options.page)) ? 1 : parseInt(options.page) || 1;

            return {
                pos: (options.startIndex ? index + options.startIndex + 1 : pos) * page,
                row: options.row ? parseInt(options.row) : row,
                col: this.view === 'row' ? index + 1 : ADAPTIVE_OFFERS_PER_ROW -
                    ((row * ADAPTIVE_OFFERS_PER_ROW) - pos) +
                    (ADAPTIVE_OFFERS_PER_ROW < OFFERS_PER_ROW_DEFAULT ? (options.groupIndex || 0) : 0),
            };
        },

        globalHandleOfferClick(event, options = {}) {
            const {
                positionOptions = {},
                customComposedPath = null,
                eventName = 'offer-click',
                source = 'productClick',
            } = options;

            let path = event.path || (event.composedPath && event.composedPath());
            if (customComposedPath) {
                path = customComposedPath;
            }

            let offerTarget = path.find(element => {
                return element.dataset && element.dataset.offerId;
            });

            if (offerTarget?.classList.contains('l-ss-c-offer-dropdown')) {
                const wrapper = this.$refs.wrapper;
                if (wrapper) {
                    offerTarget = wrapper.querySelector(`.l-ss-c-offer[data-offer-id="${offerTarget.dataset.offerId}"]`);
                }
            }

            if (offerTarget) {
                const offerId = offerTarget.dataset.offerId;
                const offer = this.offers.find(item => item.id === offerId);
                const positionIndex = offerTarget.dataset.offerIndex;

                this.$emit(eventName, Object.assign({
                    event: event,
                    source: source,
                    id: offer.id,
                    url: offer.url,
                    productClickVendor: offer.vendor || '',
                    customEventType: customComposedPath ? 'contextmenu' : null,
                }, this.getOfferPosition(positionIndex, Object.assign(positionOptions, {
                    groupIndex: offerTarget.dataset.groupIndex,
                    offersInRow: offerTarget.dataset.offersInRow,
                    page: offerTarget.dataset.page,
                    row: offerTarget.dataset.row,
                }))));
            }
        },

        addToCard(event) {
            this.globalHandleOfferClick(event, { eventName: 'add-to-cart-click', source: 'addToCart' });
        },

        removeFromCard(event) {
            this.globalHandleOfferClick(event, { eventName: 'remove-from-cart-click', source: 'removeFromCart' });
        },

        addToFavourites(event) {
            this.globalHandleOfferClick(event, { eventName: 'add-to-favourites-click', source: 'addToFavourites' });
        },

        removeFromFavourites(event) {
            this.globalHandleOfferClick(event, { eventName: 'remove-from-favourites-click', source: 'removeFromFavourites' });
        },

        addToCompare(event) {
            this.globalHandleOfferClick(event, { eventName: 'add-to-compare-click', source: 'addToCompare' });
        },

        removeFromCompare(event) {
            this.globalHandleOfferClick(event, { eventName: 'remove-from-compare-click', source: 'removeFromCompare' });
        },
    },
};
